{
  "name": "angular-portal",
  "version": "4.3.6",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.1",
    "@angular/cdk": "^22.1.1",
    "@angular/common": "^22.1.1",
    "@angular/compiler": "^22.1.1",
    "@angular/core": "^22.1.1",
    "@angular/forms": "^22.1.1",
    "@angular/google-maps": "^22.1.1",
    "@angular/material": "^22.1.1",
    "@angular/platform-browser": "^22.1.1",
    "@angular/platform-browser-dynamic": "^22.1.1",
    "@angular/pwa": "^22.1.3",
    "@angular/router": "^22.1.1",
    "@angular/service-worker": "^22.1.1",
    "@aws-amplify/ui-angular": "3.2.8",
    "@ffmpeg/core": "^0.12.10",
    "@ffmpeg/ffmpeg": "^0.12.15",
    "@ffmpeg/util": "^0.12.2",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-svg-core": "^6.5.2",
    "@fortawesome/free-brands-svg-icons": "^6.5.2",
    "@fortawesome/free-regular-svg-icons": "^6.5.2",
    "@fortawesome/free-solid-svg-icons": "^6.5.2",
    "@mediapipe/tasks-vision": "^0.10.32",
    "@snap/camera-kit": "^1.1.0",
    "angular-animations": "^0.11.0",
    "aws-amplify": "5.0.16",
    "aws-sdk": "^2.1322.0",
    "chart.js": "^4.4.2",
    "classlist.js": "^1.1.20150312",
    "file-saver": "^2.0.5",
    "firebase": "^12.5.0",
    "fix-webm-duration": "^1.0.6",
    "howler": "^2.2.4",
    "i18n-iso-countries": "^7.14.0",
    "moment": "^2.30.1",
    "ng2-charts": "^5.0.4",
    "ngx-clipboard": "^16.0.0",
    "ngx-skeleton-loader": "^9.0.0",
    "qr-code-styling": "^1.9.2",
    "rxjs": "~7.8.1",
    "tinycolor2": "^1.6.0",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.3",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.1",
    "@angular/language-service": "^22.1.1",
    "@types/dom-mediacapture-record": "^1.0.19",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^12.11.1",
    "@types/uuid": "^9.0.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.1.2",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.3",
    "typescript": "~6.0.3"
  }
}